import { useContext } from 'react'

import { OptimizelyContext } from '@optimizely/react-sdk'

import { useAuth } from 'routes/Menu/domains/auth'
import Cookies from 'utils/GoustoCookies'
import logger from 'utils/logger'

export const useDiscountSofteningV5 = (): boolean => {
  const { isAuthenticated } = useAuth()
  const { optimizely } = useContext(OptimizelyContext)

  let hasAcceptedAnalytics = false
  try {
    const consentCookieString = Cookies.get('v1_gousto_cookie_consent')
    const consentCookie = consentCookieString ? JSON.parse(consentCookieString) : {}
    hasAcceptedAnalytics = consentCookie?.categories?.includes('ANALYTICS')
  } catch (error) {
    if (error instanceof Error) {
      logger.error(error.message)
    }
  }

  const { enabled, variationKey } =
    optimizely && hasAcceptedAnalytics && !isAuthenticated
      ? optimizely.decide('beetroots_ofx_discount_softening_v5')
      : { enabled: false, variationKey: undefined }

  const isEnabled = enabled && variationKey === 't1'

  return isEnabled
}
